import {useState, useEffect, Fragment} from "react";
import {MIN_DESKTOP_SIZE} from "@/constants/general-constants";

export default function MobileSize({children}) {

    const [isMobile, setIsMobile] = useState(false);
    const [initial, setInitial] = useState(false);

    useEffect(() => {
        if (!initial) {
            handleWindowSizeChange();
            setInitial(true);
        }

        window.removeEventListener('resize', handleWindowSizeChange);
        window.addEventListener('resize', handleWindowSizeChange);

        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, [isMobile]); // eslint-disable-line

    const handleWindowSizeChange = () => {
        if (!isMobile && screen.width < MIN_DESKTOP_SIZE) {
            setIsMobile(true);
        } else if (isMobile && screen.width >= MIN_DESKTOP_SIZE) {
            setIsMobile(false);
        }
    }

    return (
        <Fragment>
            {
                isMobile ? children : null
            }
        </Fragment>
    )

}
